import {GenericLoadingComponent} from "~/components/genericLoadingComponent";
import {useIntellsysDevtoolsConfiguration} from "~/contexts/intellsysDevtoolsClientContext";

export function DefaultPendingComponent() {
    const intellsysDevtoolsConfiguration = useIntellsysDevtoolsConfiguration();

    if (intellsysDevtoolsConfiguration.insaneLogs.tanstackRouterDebugging === true) {
        console.info(+new Date(), "tanstackRouterDebugging", "?", "pendingComponent");
    }

    return <GenericLoadingComponent />;
}
